// import { React, useState, useEffect } from 'react'
// import Layouts from './layouts/layout'
// import './css/style.css';
// import quizStyles from './css/promoQuiz.module.css';
// import { NavLink, useNavigate } from 'react-router-dom';
// import { getAllQuiz } from '../services/home';
// import { useTranslation } from 'react-i18next';
// import { levels } from '../utils/levels';

// // ===================== M-PESA QUIZMASTER PROMO QUIZ CATEGORIES =====================
// const promoQuizText = {
//     "0": {
//         badge: "M-Pesa Promo",
//         title: "Pick a category & start winning",
//         subtitle: "Answer 10 questions, earn stars and climb the leaderboard",
//         prize: "Up to 20,000 MT",
//         prizeSub: "final prize",
//         dates: "15 Oct – 11 Nov 2026",
//         search: "Search category...",
//         categories: "Categories",
//         play: "Play",
//         empty: "No category found",
//         leaderboard: "Leaderboard",
//         back: "Back"
//     },
//     "3": {
//         badge: "Promoção M-Pesa",
//         title: "Escolhe uma categoria e começa a ganhar",
//         subtitle: "Responde a 10 perguntas, ganha estrelas e sobe na classificação",
//         prize: "Até 20.000 MT",
//         prizeSub: "prémio final",
//         dates: "15 Out – 11 Nov 2026",
//         search: "Procurar categoria...",
//         categories: "Categorias",
//         play: "Jogar",
//         empty: "Nenhuma categoria encontrada",
//         leaderboard: "Classificação",
//         back: "Voltar"
//     },
// };

// const PromoQuiz = () => {
//     const [allQuiz, setAllQuiz] = useState([]);
//     const [isSearchExpanded, setIsSearchExpanded] = useState(false);
//     const [searchTerm, setSearchTerm] = useState('');
//     const { t } = useTranslation();
//     const navigate = useNavigate();
//     const text = promoQuizText[localStorage.getItem('selectedLanguage')] || promoQuizText["0"];

//     const handleSearchClick = () => {
//         // Toggle the state to expand/collapse the search input box
//         setIsSearchExpanded((prevIsSearchExpanded) => !prevIsSearchExpanded);
//     };
//     const handleSearchChange = (event) => {
//         setSearchTerm(event.target.value);
//     };
//     // Filter quizzes based on the search term
//     const filteredQuizzes = allQuiz.filter((quiz) =>
//         quiz.name.toLowerCase().includes(searchTerm.toLowerCase())
//     );

//     useEffect(() => {
//         getAllQuiz(localStorage.getItem('selectedLanguage')).then((res) => {
//             console.log(res)
//             setAllQuiz(res.data)

//         }).catch((err) => {
//             console.log(err)
//         })
//     }, [])

//     return (
//         <Layouts>
//             <div className='home'>
//                 <div className="maine-div">
//                     <div className="container box-wrapper">

//                         {/* ===================== HEADER ===================== */}
//                         <div className="header">
//                             <div className="row align-items-center">
//                                 <div className="col-4 text-start">
//                                     <div className="logo d-flex align-items-center">
//                                         <button
//                                             type="button"
//                                             className={quizStyles.backButton}
//                                             onClick={() => navigate(-1)}
//                                             aria-label={text.back}
//                                         >
//                                             <span aria-hidden="true">‹</span>
//                                         </button>
//                                         <a href="#">
//                                             <img src="/image/Logo_new.png" alt="Logo" />
//                                         </a>
//                                         {/* <span className='logo-name'>CaliQuiz</span> */}
//                                     </div>
//                                 </div>
//                                 <div className="col-8 text-end">
//                                     <NavLink to="/promo/leaderboard" className={quizStyles.headerLeaderboard}>
//                                         🏅 {text.leaderboard}
//                                     </NavLink>
//                                 </div>
//                             </div>
//                         </div>

//                         {/* ===================== PROMO HERO ===================== */}
//                         <div className={quizStyles.hero}>
//                             <span className={quizStyles.heroBadge}>💰 {text.badge}</span>
//                             <h2 className={quizStyles.heroTitle}>{text.title}</h2>
//                             <p className={quizStyles.heroSubtitle}>{text.subtitle}</p>

//                             <div className={quizStyles.heroPrizeRow}>
//                                 <div className={quizStyles.heroPrize}>
//                                     <span className={quizStyles.heroPrizeAmount}>{text.prize}</span>
//                                     <span className={quizStyles.heroPrizeSub}>{text.prizeSub}</span>
//                                 </div>
//                                 <span className={quizStyles.heroDates}>📅 {text.dates}</span>
//                             </div>
//                             <span className={quizStyles.heroCoin} aria-hidden="true">🏆</span>
//                         </div>

//                         {/* ===================== SECTION TITLE + SEARCH ===================== */}
//                         <div className={quizStyles.sectionBar}>
//                             <h3 className={quizStyles.sectionTitle}>
//                                 {text.categories}
//                                 <span className={quizStyles.sectionCount}>{filteredQuizzes.length}</span>
//                             </h3>
//                             <button
//                                 type="button"
//                                 className={quizStyles.searchToggle}
//                                 onClick={handleSearchClick}
//                                 aria-label="Search"
//                             >
//                                 <img src="/image/search.png" alt="" />
//                             </button>
//                         </div>

//                         {isSearchExpanded && (
//                             <input
//                                 type="text"
//                                 placeholder={text.search}
//                                 className={quizStyles.searchInput}
//                                 onChange={handleSearchChange}
//                                 autoFocus
//                             />
//                         )}

//                         {/* ===================== CATEGORY GRID ===================== */}
//                         <ul className={quizStyles.grid}>
//                             {
//                                 filteredQuizzes && filteredQuizzes.map((quiz) => {

//                                     const stateData = { qid: quiz, lavel: levels[0] };

//                                     return <li className={quizStyles.gridItem} key={quiz.id}>
//                                         <NavLink to='/promo/game2' className={quizStyles.card} state={stateData}>
//                                             <div className={quizStyles.cardImage}>
//                                                 {quiz?.image ? (
//                                                     <img src={quiz?.image} alt="Quiz" />
//                                                 ) : (
//                                                     <img src="/image/science.png" alt="Quiz" />
//                                                 )}
//                                             </div>
//                                             <h4 className={quizStyles.cardTitle}>{quiz?.name}</h4>
//                                             {quiz?.description && (
//                                                 <p className={quizStyles.cardDesc}>{quiz?.description}</p>
//                                             )}
//                                             <span className={quizStyles.cardPlay}>
//                                                 {text.play} <span aria-hidden="true">›</span>
//                                             </span>
//                                         </NavLink>
//                                     </li>
//                                 })
//                             }
//                         </ul>

//                         {filteredQuizzes.length === 0 && allQuiz.length > 0 && (
//                             <p className={quizStyles.empty}>{text.empty}</p>
//                         )}

//                     </div>
//                 </div>
//             </div>
//         </Layouts>
//     )
// }

// export default PromoQuiz



import { React, useState, useEffect } from 'react'
import Layouts from './layouts/layout'
import './css/style.css';
import quizStyles from './css/promoQuiz.module.css';
import { NavLink, useNavigate } from 'react-router-dom';
import { getAllQuiz } from '../services/home';
import { useTranslation } from 'react-i18next';
import { levels } from '../utils/levels';

// ===================== FEATURED QUIZ (shown first, separately) =====================
const FEATURED_QUIZ_ID = "d0cc30f3-df55-4d95-92a8-fa6d4bf7fa73";

// ===================== M-PESA QUIZMASTER PROMO QUIZ CATEGORIES =====================
const promoQuizText = {
    "0": {
        badge: "M-Pesa Promo",
        title: "Pick a category & start winning",
        subtitle: "Answer 10 questions, earn stars and climb the leaderboard",
        prize: "Up to 20,000 MT",
        prizeSub: "final prize",
        dates: "15 Oct – 11 Nov 2026",
        search: "Search category...",
        categories: "Categories",
        play: "Play",
        empty: "No category found",
        leaderboard: "Leaderboard",
        back: "Back",
        featuredRibbon: "Featured",
        featuredTag: "Most popular",
        featuredPlay: "Play now"
    },
    "3": {
        badge: "Promoção M-Pesa",
        title: "Escolhe uma categoria e começa a ganhar",
        subtitle: "Responde a 10 perguntas, ganha estrelas e sobe na classificação",
        prize: "Até 20.000 MT",
        prizeSub: "prémio final",
        dates: "15 Out – 11 Nov 2026",
        search: "Procurar categoria...",
        categories: "Categorias",
        play: "Jogar",
        empty: "Nenhuma categoria encontrada",
        leaderboard: "Classificação",
        back: "Voltar",
        featuredRibbon: "Destaque",
        featuredTag: "Mais popular",
        featuredPlay: "Jogar agora"
    },
};

const PromoQuiz = () => {
    const [allQuiz, setAllQuiz] = useState([]);
    const [isSearchExpanded, setIsSearchExpanded] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    // const { t } = useTranslation();
    // const navigate = useNavigate();
    // const text = promoQuizText[localStorage.getItem('selectedLanguage')] || promoQuizText["0"];


    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [language, setLanguage] = useState(
        localStorage.getItem('selectedLanguage') || "0",
    );
    const text = promoQuizText[language] || promoQuizText["0"];

    useEffect(() => {
        localStorage.setItem('selectedLanguage', language);
        i18n.changeLanguage(language);
        getAllQuiz(language).then((res) => {
            console.log(res)
            setAllQuiz(res.data)

        }).catch((err) => {
            console.log(err)
        })
    }, [language])

    // 

    const handleSearchClick = () => {
        // Toggle the state to expand/collapse the search input box
        setIsSearchExpanded((prevIsSearchExpanded) => !prevIsSearchExpanded);
    };
    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };
    // Filter quizzes based on the search term
    const filteredQuizzes = allQuiz.filter((quiz) =>
        quiz.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Featured quiz on top, rest in the grid (no duplicate)
    const featuredQuiz = filteredQuizzes.find((quiz) => quiz.id === FEATURED_QUIZ_ID);
    const otherQuizzes = filteredQuizzes.filter((quiz) => quiz.id !== FEATURED_QUIZ_ID);

    // useEffect(() => {
    //     getAllQuiz(localStorage.getItem('selectedLanguage')).then((res) => {
    //         console.log(res)
    //         setAllQuiz(res.data)

    //     }).catch((err) => {
    //         console.log(err)
    //     })
    // }, [])

    return (
        <Layouts>
            <div className='home'>
                <div className="maine-div">
                    <div className="container box-wrapper">

                        {/* ===================== HEADER ===================== */}
                        <div className="header">
                            <div className="row align-items-center">
                                <div className="col-4 text-start">
                                    <div className="logo d-flex align-items-center">
                                        <button
                                            type="button"
                                            className={quizStyles.backButton}
                                            onClick={() => navigate(-1)}
                                            aria-label={text.back}
                                        >
                                            <span aria-hidden="true">‹</span>
                                        </button>
                                        <a href="#">
                                            <img src="/image/Logo_new.png" alt="Logo" />
                                        </a>
                                        {/* <span className='logo-name'>CaliQuiz</span> */}
                                    </div>
                                </div>
                                {/* <div className="col-8 text-end">
                                    <NavLink to="/promo/leaderboard" className={quizStyles.headerLeaderboard}>
                                        🏅 {text.leaderboard}
                                    </NavLink>
                                </div> */}

                                                                <div className="col-8 text-end">
                                    <div className={quizStyles.headerActions}>
                                        <select
                                            className={`choose-option ${quizStyles.langSelect}`}
                                            value={language}
                                            onChange={(event) => setLanguage(event.target.value)}
                                        >
                                            <option value="0">English</option>
                                            <option value="3">Portuguese</option>
                                        </select>
                                        {/* <NavLink to="/promo/leaderboard" className={quizStyles.headerLeaderboard}>
                                            🏅 {text.leaderboard}
                                        </NavLink> */}
                                    </div>
                                </div>

                            </div>
                        </div>

                        {/* ===================== PROMO HERO ===================== */}
                        <div className={quizStyles.hero}>
                            <span className={quizStyles.heroBadge}>💰 {text.badge}</span>
                            <h2 className={quizStyles.heroTitle}>{text.title}</h2>
                            <p className={quizStyles.heroSubtitle}>{text.subtitle}</p>

                            <div className={quizStyles.heroPrizeRow}>
                                <div className={quizStyles.heroPrize}>
                                    <span className={quizStyles.heroPrizeAmount}>{text.prize}</span>
                                    <span className={quizStyles.heroPrizeSub}>{text.prizeSub}</span>
                                </div>
                                <span className={quizStyles.heroDates}>📅 {text.dates}</span>
                            </div>
                            <span className={quizStyles.heroCoin} aria-hidden="true">🏆</span>
                        </div>

                        {/* ===================== SECTION TITLE + SEARCH ===================== */}
                        <div className={quizStyles.sectionBar}>
                            <h3 className={quizStyles.sectionTitle}>
                                {text.categories}
                                <span className={quizStyles.sectionCount}>{filteredQuizzes.length}</span>
                            </h3>
                            <button
                                type="button"
                                className={quizStyles.searchToggle}
                                onClick={handleSearchClick}
                                aria-label="Search"
                            >
                                <img src="/image/search.png" alt="" />
                            </button>
                        </div>

                        {isSearchExpanded && (
                            <input
                                type="text"
                                placeholder={text.search}
                                className={quizStyles.searchInput}
                                onChange={handleSearchChange}
                                autoFocus
                            />
                        )}

                        {/* ===================== FEATURED QUIZ ===================== */}
                        {featuredQuiz && (
                            <NavLink
                                to='/promo/game2'
                                className={quizStyles.featuredCard}
                                state={{ qid: featuredQuiz, lavel: levels[0] }}
                            >
                                <span className={quizStyles.featuredRibbon}>⭐ {text.featuredRibbon}</span>

                                <div className={quizStyles.featuredBody}>
                                    <div className={quizStyles.featuredImage}>
                                        {featuredQuiz?.image ? (
                                            <img src={featuredQuiz?.image} alt="Quiz" />
                                        ) : (
                                            <img src="/image/science.png" alt="Quiz" />
                                        )}
                                    </div>
                                    <div className={quizStyles.featuredInfo}>
                                        <span className={quizStyles.featuredTag}>🔥 {text.featuredTag}</span>
                                        <h4 className={quizStyles.featuredTitle}>{featuredQuiz?.name}</h4>
                                        {featuredQuiz?.description && (
                                            <p className={quizStyles.featuredDesc}>{featuredQuiz?.description}</p>
                                        )}
                                    </div>
                                </div>

                                <span className={quizStyles.featuredPlay}>
                                    {text.featuredPlay} <span aria-hidden="true">›</span>
                                </span>
                            </NavLink>
                        )}

                        {/* ===================== CATEGORY GRID ===================== */}
                        <ul className={quizStyles.grid}>
                            {
                                otherQuizzes && otherQuizzes.map((quiz) => {

                                    const stateData = { qid: quiz, lavel: levels[0] };

                                    return <li className={quizStyles.gridItem} key={quiz.id}>
                                        <NavLink to='/promo/game2' className={quizStyles.card} state={stateData}>
                                            <div className={quizStyles.cardImage}>
                                                {quiz?.image ? (
                                                    <img src={quiz?.image} alt="Quiz" />
                                                ) : (
                                                    <img src="/image/science.png" alt="Quiz" />
                                                )}
                                            </div>
                                            <h4 className={quizStyles.cardTitle}>{quiz?.name}</h4>
                                            {quiz?.description && (
                                                <p className={quizStyles.cardDesc}>{quiz?.description}</p>
                                            )}
                                            <span className={quizStyles.cardPlay}>
                                                {text.play} <span aria-hidden="true">›</span>
                                            </span>
                                        </NavLink>
                                    </li>
                                })
                            }
                        </ul>

                        {filteredQuizzes.length === 0 && allQuiz.length > 0 && (
                            <p className={quizStyles.empty}>{text.empty}</p>
                        )}

                    </div>
                </div>
            </div>
        </Layouts>
    )
}

export default PromoQuiz